import React, { useEffect } from 'react';
import config from '@plone/volto/registry';
import Helmet from '@plone/volto/helpers/Helmet/Helmet';

const EU_REGIONS = [
  'AT',
  'BE',
  'BG',
  'CY',
  'CZ',
  'DE',
  'DK',
  'EE',
  'ES',
  'FI',
  'FR',
  'GB',
  'GG',
  'GR',
  'HR',
  'HU',
  'IE',
  'IM',
  'IT',
  'JE',
  'LT',
  'LU',
  'LV',
  'MT',
  'NL',
  'NO',
  'PL',
  'PT',
  'RO',
  'SE',
  'SI',
  'SK',
];

const CookieConsent: React.FC = () => {
  const { settings } = config;
  const gaId = settings.gaMeasurementId as string | undefined;
  const cbId = settings.cookiebotDomainGroupId as string | undefined;

  useEffect(() => {
    if (document.getElementById('Cookiebot')) {
      return;
    }

    const script = document.createElement('script');
    script.id = 'Cookiebot';
    script.src = 'https://consent.cookiebot.com/uc.js';
    if (cbId) {
      script.setAttribute('data-cbid', cbId);
    }
    script.setAttribute('data-blockingmode', 'auto');
    script.setAttribute(
      'data-georegions',
      JSON.stringify({
        region: EU_REGIONS.join(', '),
        cbid: 'a7821bfd-f369-4bfd-8dfe-642599cb4fc4',
      }),
    );
    script.type = 'text/javascript';

    document.head.appendChild(script);

    return () => {
      const existingScript = document.getElementById('Cookiebot');
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, [cbId]);

  return (
    <Helmet>
      <script data-cookieconsent="ignore">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag() { dataLayer.push(arguments); }
          
          // EU-specific settings
          gtag('consent', 'default', {
            'ad_personalization': 'denied',
            'ad_storage': 'denied',
            'ad_user_data': 'denied',
            'analytics_storage': 'denied',
            'functionality_storage': 'denied',
            'personalization_storage': 'denied',
            'region': ${JSON.stringify(EU_REGIONS)},
            'wait_for_update': 500,
          });
          
          // Default settings for non-EU regions
          gtag('consent', 'default', {
            'ad_personalization': 'granted',
            'ad_storage': 'granted',
            'ad_user_data': 'granted',
            'analytics_storage': 'granted',
            'functionality_storage': 'granted',
            'personalization_storage': 'granted',
            'security_storage': 'granted',
            'wait_for_update': 500,
          });
          
          gtag('set', 'ads_data_redaction', true);
          gtag('set', 'url_passthrough', false);
        `}
      </script>

      <script type="text/plain" data-cookieconsent="statistics" defer>
        {`
          (function(w,d,s,l,i){
            w[l]=w[l]||[];
            w[l].push({'gtm.start': new Date().getTime(), event:'gtm.js'});
            var f=d.getElementsByTagName(s)[0],
                j=d.createElement(s),
                dl=l!='dataLayer'?'&l='+l:'';
            j.async=true;
            j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
            f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','` +
          gaId +
          `');
        `}
      </script>
    </Helmet>
  );
};

export default CookieConsent;
